import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { WA_LABEL, fmtDate } from "../SuperHeader";
import { useAdminFetch, TabState } from "../useAdminFetch";

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-4 py-1.5 border-b border-slate-100 text-sm"><span className="text-slate-500">{k}</span><span className="font-mono text-xs text-right break-all">{v || "—"}</span></div>
);

export default function WhatsAppTab({ cid }) {
  const { data, error, loading } = useAdminFetch(`/admin/companies/${cid}/whatsapp`);
  const c = data?.connection || {};
  const wa = WA_LABEL[data?.state] || WA_LABEL.none;
  return (
    <div className="grid lg:grid-cols-2 gap-4" data-testid="whatsapp-tab">
      <Card className="p-5 border-slate-200">
        <TabState loading={loading} error={error} testid="wa">
          <div className="mb-3"><Badge className={wa.cls} data-testid="wa-state">{wa.text}</Badge></div>
          <Row k="Mode" v={c.mode} />
          <Row k="Display name" v={c.display_name} />
          <Row k="Phone number" v={c.phone_number} />
          <Row k="Phone Number ID" v={c.phone_number_id} />
          <Row k="WABA ID" v={c.waba_id} />
          <Row k="Business ID" v={c.business_id} />
          <Row k="API version" v={c.api_version} />
          <Row k="Access token" v={c.access_token_masked} />
          <Row k="Last test" v={c.last_test_at ? `${fmtDate(c.last_test_at)} · ${c.last_test_ok ? "OK" : "Failed"}` : null} />
          <Row k="Last test message" v={c.last_test_message} />
          <p className="text-[11px] text-slate-400 mt-3">Tokens, app secrets and webhook verify tokens are never shown here.</p>
        </TabState>
      </Card>
      <Card className="p-5 border-slate-200">
        <h3 className="font-semibold text-slate-900 mb-2">Guidance</h3>
        <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-700" data-testid="wa-guidance">{(data?.guidance || []).map((g, i) => <li key={i}>{g}</li>)}</ul>
      </Card>
    </div>
  );
}
